export default __webpack_public_path__ + "static/media/riu.e11d1cb8.png";